import { Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

const NO_COMPONENT = -1;

@Directive({
  selector: '[gasClickOutside]',
})
export class GasClickOutsideDirective implements OnDestroy {
  @Output('handleClick')
  public handleClick$ = new EventEmitter<boolean>(false);

  public bindFunction: () => void;

  constructor(
    private elementRef: ElementRef,
  ) {
    /** для правильной отписки записывае результат работы bind в отдельную переменную */
    this.bindFunction =  this.clickHandler.bind(this);
    document.addEventListener('click', this.bindFunction);
  }

  public clickHandler(event: any): void {
    if (event.composedPath().indexOf(this.elementRef.nativeElement) === NO_COMPONENT) {
      this.handleClick$.emit(true);
    }
  }

  public ngOnDestroy(): void {
    document.removeEventListener('click', this.bindFunction);
  }
}
